import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AzgivService {

	// Is control pane shown
	public isControlPane = new BehaviorSubject(true);
	// Control pane resize end
	public controlPaneResizeEnd = new BehaviorSubject(null);

	constructor() { }

}
